import { Button } from '@src/stories/elements/Button/Button';
import React from 'react';

interface MinicartActionsProps {
  show_cart?: boolean;
  block?: any;
  isLoading: boolean;
  settings?: {
    // Content settings
    show_view_cart?: boolean;
    checkout_button_text?: string;
    checkout_button_style?: string;
    checkout_button_size?: string;
    checkout_cta_style_type?: string;
    cart_button_text?: string;
    cart_button_style?: string;
    cart_button_size?: string;
    cart_cta_style_type?: string;

    // Appearance settings
    color_schema?: string;
    border_radius?: number;

    // Layout & Spacing settings
    direction?: string;
    padding_top?: number;
    padding_bottom?: number;
    padding_left_right?: number;
    margin_top?: number;
    margin_bottom?: number;
    margin_left_right?: number;
    gap?: number;

    // Divider settings
    show_divider?: boolean;
    divider_color?: string;
    divider_thickness?: number;

    // Legacy settings (for backward compatibility) - removed unused settings
  };
}

export const MinicartActions = ({ show_cart = true, settings = {}, block, isLoading }: MinicartActionsProps) => {
  // Content settings
  const showViewCart = settings?.show_view_cart !== false;
  const checkoutButtonText = settings?.checkout_button_text || 'CHECKOUT';
  const checkoutButtonStyle = settings?.checkout_button_style || 'primary';
  const checkoutButtonSize = settings?.checkout_button_size || 'lg';
  const checkoutCtaStyleType = settings?.checkout_cta_style_type || 'button';
  const cartButtonText = settings?.cart_button_text || 'VIEW BAG';
  const cartButtonStyle = settings?.cart_button_style || 'secondary';
  const cartButtonSize = settings?.cart_button_size || 'lg';
  const cartCtaStyleType = settings?.cart_cta_style_type || 'button';

  // Layout & Spacing
  const direction = settings?.direction || 'column';
  const paddingTop = settings?.padding_top ?? 0;
  const paddingBottom = settings?.padding_bottom ?? 0;
  const paddingLeftRight = settings?.padding_left_right ?? 0;
  const marginTop = settings?.margin_top ?? 0;
  const marginBottom = settings?.margin_bottom ?? 0;
  const marginLeftRight = settings?.margin_left_right ?? 0;
  const gap = settings?.gap ?? 10;

  // Appearance
  const borderRadius = settings?.border_radius || 0;

  // Divider settings
  const showDivider = settings?.show_divider || false;
  const dividerColor = settings?.divider_color || '#e5e7eb';
  const dividerThickness = settings?.divider_thickness || 1;

  // Legacy support - removed unused settings

  // Container styles
  const containerStyle = {
    marginTop: `${marginTop}px`,
    marginBottom: `${marginBottom}px`,
    marginLeft: `${marginLeftRight}px`,
    marginRight: `${marginLeftRight}px`,
    paddingTop: `${paddingTop}px`,
    paddingBottom: `${paddingBottom}px`,
    paddingLeft: `${paddingLeftRight}px`,
    paddingRight: `${paddingLeftRight}px`,
    display: 'flex',
    flexDirection: direction === 'row' ? 'row' : 'column',
    gap: `${gap}px`,
    borderRadius: `${borderRadius}px`,
    width: '100%'
  } as React.CSSProperties;

  // Get the correct color schema from block data
  const colorSchema = block?.color_schema || settings?.color_schema;

  return (
    <div
      className={`minicart-actions items-center ${colorSchema ? `color-${colorSchema}` : ''}`}
      style={containerStyle}
    >
      <Button
        type='button'
        style={checkoutButtonStyle}
        size={checkoutButtonSize}
        styleType={checkoutCtaStyleType}
        className={`minicart-actions__checkout w-full`}
        label={checkoutButtonText}
        onClick={() => (window.location.href = '/checkout')}
        disabled={isLoading}
      />

      {show_cart && showViewCart && (
        <Button
          type='button'
          style={cartButtonStyle}
          size={cartButtonSize}
          styleType={cartCtaStyleType}
          className={`minicart-actions__cart`}
          label={cartButtonText}
          onClick={() => (window.location.href = '/cart')}
          disabled={isLoading}
        />
      )}

      {showDivider && (
        <div
          style={{
            width: '100%',
            height: dividerThickness,
            backgroundColor: dividerColor
          }}
        />
      )}
    </div>
  );
};
